import React from 'react';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
// import CloseIcon from '@material-ui/icons/Close';
import { capitalizeAllWords } from '../textHelper';
import AfitdAutocompleteLite from './AfitdAutocompleteLite';
// import AfitdTextField from './AfitdTextField';

// import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';
// import _map from 'lodash/map';
import _get from 'lodash/get';
// import _filter from 'lodash/filter';
// import _includes from 'lodash/includes';
import _trim from 'lodash/trim';
import _isArray from 'lodash/isArray';
import _some from 'lodash/some';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
// import _toLower from 'lodash/toLower';

// const styles = theme => ({
// });

const defaultStyle = { width: '100%', padding: 0, margin: 0 };
const defaultFilter = createFilterOptions({ limit: 6 });

//---------------------------------------------------------------------------------
// Capitalize
//---------------------------------------------------------------------------------
const defaultFilterOptionsCapitalized = (value, options, params) => {
    const inputValue = _get(params, 'inputValue');
    const inputValueCapitalized = capitalizeAllWords(inputValue);
    let filteredOptions = defaultFilter(options, params);
    const isNew = !_some(filteredOptions, option => option === _trim(inputValueCapitalized));
    let isAdded = false;

    // if option(s) selected, check if inputValue is new or if it is already in selection
    if ((_isArray(value) && !_isEmpty(value)) || (!_isArray(value) && !_isNil(value))) {
        const selectedOptions = _isArray(value) ? value : [value];
        isAdded = _some(selectedOptions, selectedOption => selectedOption?.inputValue === _trim(inputValueCapitalized));
    }

    // Suggest the creation of a new value
    if (inputValue === '') {
        return [];
    } else if (isNew && !isAdded) {
        filteredOptions.push({
            inputValue: inputValueCapitalized,
            label: `Add "${inputValueCapitalized}"`,
        });
    }

    return filteredOptions;
};
//---------------------------------------------------------------------------------

//---------------------------------------------------------------------------------
// Default
//---------------------------------------------------------------------------------
const defaultFilterOptions = (value, options, params) => {
    const inputValue = _get(params, 'inputValue');
    let filteredOptions = defaultFilter(options, params);
    const isNew = !_some(filteredOptions, option => option === _trim(inputValue));
    let isAdded = false;

    // if option(s) selected, check if inputValue is new or if it is already in selection
    if ((_isArray(value) && !_isEmpty(value)) || (!_isArray(value) && !_isNil(value))) {
        const selectedOptions = _isArray(value) ? value : [value];
        isAdded = _some(selectedOptions, selectedOption => selectedOption?.inputValue === _trim(inputValue));
    }

    // Suggest the creation of a new value
    if (inputValue === '') {
        return [];
    } else if (isNew && !isAdded) {
        filteredOptions.push({
            inputValue,
            label: `Add "${inputValue}"`,
        });
    }

    return filteredOptions;
};

const defaultGetOptionLabel = option => {
    // Add "xxx" option created dynamically: object {inputValue, label}
    if (option?.inputValue) {
        return option.inputValue;
    }
    // Regular option (string) or value selected with enter, right from the input
    return option;
};

const defaultRenderOption = option => {
    // Add "xxx" option created dynamically: object {inputValue, label}
    if (option?.inputValue) {
        return option.label;
    }
    // Regular option (string) or value selected with enter, right from the input
    return option;
};
//---------------------------------------------------------------------------------

const AfitdAutocompleteCreatable = props => {
    const {
        style = defaultStyle,
        filterOptions: filterOptionsProp,
        getOptionLabel = defaultGetOptionLabel,
        renderOption = defaultRenderOption,
        isCapitalize,
        value,
        ...otherProps
    } = props;

    const filterOptions = filterOptionsProp || isCapitalize ? defaultFilterOptionsCapitalized.bind(null, value) : defaultFilterOptions.bind(null, value);

    return <AfitdAutocompleteLite getOptionLabel={getOptionLabel} renderOption={renderOption} filterOptions={filterOptions} style={style} value={value} {...otherProps} />;
};

export default AfitdAutocompleteCreatable;
// export default withStyles(styles)(AfitdAutocomplete);
